import { forwardRef, useState, useEffect } from 'react';
import clsx from 'clsx';

import { Input } from '~/shared/components/Input';
import { durationUnitMap } from '~/settings/utils/configValueParser';
import Typography from '~/shared/components/Typography';

interface DurationInputProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
  className?: string;
  disabled?: boolean;
  unit?: string; // API unit format (e.g., 's', 'm', 'h')
}

const DurationInput = forwardRef<HTMLInputElement, DurationInputProps>(
  ({ value, onChange, error, className, disabled, unit = 's' }, ref) => {
    const [numericValue, setNumericValue] = useState('');
    const displayUnit = durationUnitMap[unit] || 's';

    useEffect(() => {
      if (value) {
        const durationRegex = /^(\d+(?:\.\d+)?)\s*([a-z]+)?$/i;
        const match = value.match(durationRegex);

        if (match) {
          setNumericValue(match[1]);
        }
      }
    }, [value]);

    const handleValueChange = (newValue: string) => {
      setNumericValue(newValue);
      onChange(`${newValue}${unit}`);
    };

    return (
      <Input
        ref={ref}
        type="number"
        value={numericValue}
        onChange={(e) => handleValueChange(e.target.value)}
        error={error}
        disabled={disabled}
        wrapperClassName={clsx('max-w-[160px]', className)}
        inputClassName="px-1!"
        step="any"
        rightAdornment={
          <Typography variant="p3" color="text-gray-700">
            {displayUnit}
          </Typography>
        }
        rightAdornmentClassName="right-1!"
      />
    );
  }
);

DurationInput.displayName = 'DurationInput';

export default DurationInput;
